import { render, staticRenderFns } from "./AddonListTable.vue?vue&type=template&id=39bff1ae"
import script from "./AddonListTable.vue?vue&type=script&lang=js"
export * from "./AddonListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports